import { React, PT, WithData, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Table, Segment, Checkbox, Form } from 'semantic-ui-react';
import { Auth, Nav } from '../../components';

class BaseQueues extends React.Component {
  state = {
    filterZero: true,
    search: '',
    column: 'ready',
    direction: 'descending',
  }

  handleSort = clickedColumn => () => {
    const { column, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        direction: 'ascending',
      });
    } else {
      this.setState({
        direction: direction === 'ascending' ? 'descending' : 'ascending',
      });
    }
  }

  sortValue(colName) {
    const { column, direction } = this.state;
    if (column === colName) {
      return direction;
    }
    return undefined;
  }

  render() {
    const { column, direction, filterZero, search } = this.state;
    const { data, loading, onSelected } = this.props;

    const dir = direction === 'ascending' ? 1 : -1;
    const queues = data ? data.queues
      .filter(f => !(filterZero
        && f.messages_ready === 0
        && f.messages_unacknowledged === 0))
      .filter(f => !search || f.name.indexOf(search) >= 0)
      .sort((a, b) => {
        switch (column) {
          case 'name':
            return (a.name.localeCompare(b.name)) * dir;
          case 'messages_ready':
            return ((a.messages_ready - b.messages_ready) * dir)
              || (a.name.localeCompare(b.name));
          case 'messages_unacknowledged':
            return ((a.messages_unacknowledged - b.messages_unacknowledged) * dir)
              || (a.name.localeCompare(b.name));
          default:
            return 0;
        }
      }) : [];


    return (
      <Auth forRoles="admin.superuser,admin.system.queues">
        <Nav>
          <div>
            <h1>Queues</h1>
            <Dimmer.Dimmable as={Segment} dimmed={loading}>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>
              <Table sortable striped selectable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>
                      <Checkbox
                        toggle
                        checked={filterZero}
                        onChange={() => this.setState({ filterZero: !filterZero })}
                        label="Show only queues with messages"
                      />
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan="2">
                      <Form.Input
                        fluid
                        placeholder="Search..."
                        onChange={({ target: { value } }) => this.setState({ search: value })}
                        value={search}
                      />
                    </Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell sorted={this.sortValue('name')} onClick={this.handleSort('name')}>Name</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={this.sortValue('messages_ready')} onClick={this.handleSort('messages_ready')}>Ready</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center" sorted={this.sortValue('messages_unacknowledged')} onClick={this.handleSort('messages_unacknowledged')}>Unacked</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {queues.map(d => (
                    <Table.Row
                      key={d.name}
                      onClick={() => onSelected(d)}
                    >
                      <Table.Cell>{d.name}</Table.Cell>
                      <Table.Cell textAlign="center">{d.messages_ready}</Table.Cell>
                      <Table.Cell textAlign="center">{d.messages_unacknowledged}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </Dimmer.Dimmable>
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseQueues.propTypes = {
  data: PT.shape({
    features: PT.arrayOf(PT.shape({
      name: PT.string,
      internal_name: PT.string,
    })),
  }),
  loading: PT.bool,
  onSelected: PT.func.isRequired,
};

BaseQueues.defaultProps = { loading: false, data: null };

export const Queues = withRouter(({ history }) => (
  <WithData url="/system/queues">
    <BaseQueues onSelected={q => history.push(`/system/queues/${q.name}`)} />
  </WithData>
));
